import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ViewMode = 'standard' | 'admin';

interface ViewModeStore {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  toggleViewMode: () => void;
}

export const useViewModeStore = create<ViewModeStore>()(
  persist(
    (set, get) => ({
      viewMode: 'standard',
      setViewMode: (mode) => set({ viewMode: mode }),
      toggleViewMode: () => {
        const current = get().viewMode;
        const newMode = current === 'standard' ? 'admin' : 'standard';
        set({ viewMode: newMode });
      },
    }),
    {
      name: 'view-mode-storage', // localStorage key
    }
  )
); 